import type { ProcessableImageType, ProcessableServerImageType } from '@/lib/types/common.types'

export const normalizeImage = (image: ProcessableServerImageType): ProcessableImageType => {
  return {
    key: image.key,
    baseUrl: image.base_url,
    contentType: image.content_type,
    url: image.url,
  }
}
